import { render, staticRenderFns } from "./pre_text_1.0.vue?vue&type=template&id=41ee4e65&scoped=true"
import script from "./pre_text_1.0.vue?vue&type=script&lang=js"
export * from "./pre_text_1.0.vue?vue&type=script&lang=js"
import style0 from "./pre_text_1.0.vue?vue&type=style&index=0&id=41ee4e65&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ee4e65",
  null
  
)

export default component.exports